import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const PICKUP_ETA_KEY = 'dispatch.pickupEta';
export const PICKUP_ETA_BOUNDS = {
    gridMeters: { min: 100, max: 2_000 },
    bandSeconds: { min: 60, max: 3_600 },
    maxBands: 12,
    longStepSeconds: { min: 60, max: 1_800 },
};
export const DEFAULT_PICKUP_ETA = { gridMeters: 400, bandsSeconds: [120, 180, 300, 420, 600], longStepSeconds: 300 };
export const STRICT_PICKUP_ETA = { gridMeters: PICKUP_ETA_BOUNDS.gridMeters.max, bandsSeconds: [], longStepSeconds: PICKUP_ETA_BOUNDS.longStepSeconds.max };
export const PICKUP_ETA_POLICY_REASON_CODES = ['PICKUP_ETA_POLICY_GOVERNED', 'PICKUP_ETA_POLICY_DEFAULT', 'PICKUP_ETA_POLICY_INVALID'];
export function pickupEtaIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['gridMeters', 'bandsSeconds', 'longStepSeconds']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = PICKUP_ETA_BOUNDS;
    if (!intWithin(v.gridMeters, b.gridMeters.min, b.gridMeters.max))
        return 'INVALID_GRID_METERS';
    const bands = v.bandsSeconds;
    if (!Array.isArray(bands) || bands.length > b.maxBands || bands.some((s) => !intWithin(s, b.bandSeconds.min, b.bandSeconds.max)))
        return 'INVALID_BANDS_SECONDS';
    for (let i = 1; i < bands.length; i += 1)
        if (bands[i] <= bands[i - 1])
            return 'BANDS_NOT_ASCENDING';
    if (!intWithin(v.longStepSeconds, b.longStepSeconds.min, b.longStepSeconds.max))
        return 'INVALID_LONG_STEP_SECONDS';
    return undefined;
}
export const PICKUP_ETA_SPEC = {
    key: PICKUP_ETA_KEY,
    issue: pickupEtaIssue,
    copy: (v) => ({ gridMeters: v.gridMeters, bandsSeconds: [...v.bandsSeconds], longStepSeconds: v.longStepSeconds }),
    defaultValue: DEFAULT_PICKUP_ETA,
    strictValue: STRICT_PICKUP_ETA,
    reasonPrefix: 'PICKUP_ETA_POLICY',
    constraintClass: 'privacy',
    // Never finer than a layer above.
    tighten: (deciding, enclosing) => ({
        gridMeters: Math.max(deciding.gridMeters, enclosing.gridMeters),
        bandsSeconds: deciding.bandsSeconds.filter((s) => enclosing.bandsSeconds.includes(s)),
        longStepSeconds: Math.max(deciding.longStepSeconds, enclosing.longStepSeconds),
    }),
};
export function pickupEtaSetting(input) {
    return marketRuleSetting(PICKUP_ETA_SPEC, input);
}
export function resolvePickupEtaPolicy(settings, marketId, at, regionCode) {
    return resolveMarketRule(PICKUP_ETA_SPEC, settings, marketId, at, regionCode);
}
/** Pure: a raw estimate rounded UP into its band, then whole long steps past the last one - never finer than the rule. */
export function coarseEtaSeconds(rawSeconds, value) {
    const raw = Math.max(0, rawSeconds);
    const band = value.bandsSeconds.find((b) => raw <= b);
    return band ?? Math.max(value.longStepSeconds, Math.ceil(raw / value.longStepSeconds) * value.longStepSeconds);
}
//# sourceMappingURL=pickup-eta-policy.js.map